import { ToastContextDispatch } from "Context/CommonContext";
import { StudentContext } from "Context/StudentContext";
import StudentInsightListing from "Pages/StudentPortfolio/StudentInsight/StudentInsightListing";
import React, { useContext, useLayoutEffect, useState } from "react";
import {
  BASE_URL,
  GET_STUDENT_INSIGHT,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
interface IInsightHome {
  viewAllComments?: any;
  setViewAllComments?: any;
}

function StudentInsightHome({
  viewAllComments,
  setViewAllComments,
}: IInsightHome) {
  const { selectedStudent } = useContext<any>(StudentContext);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [studentInsight, setStudentInsight] = useState<any>("");
  const [studentInsightLoading, setStudentInsightLoading] =
    useState<any>(false);
  const [studentInsightError, setStudentInsightError] = useState<any>(null);
  useLayoutEffect(() => {
    const insightObjectString = localStorage.getItem("insightObject");
    const storageInsightObject = insightObjectString
      ? JSON.parse(insightObjectString)
      : null;
    if (storageInsightObject && Array.isArray(storageInsightObject)) {
      const filteredObject = storageInsightObject.filter(
        (elm: any) => elm.studentPSID == selectedStudent?.psid
      );
      if (filteredObject && filteredObject.length) {
        const obj = {
          ...filteredObject[0],
          persisted: true,
        };
        setStudentInsight(obj);
      }
    }
  }, [selectedStudent]);

  const handleGenerateinsights = () => {
    setStudentInsightError(null);
    setStudentInsightLoading(true);
    const urls =
      BASE_URL +
      GET_STUDENT_INSIGHT +
      "?psid=" +
      selectedStudent?.psid +
      "&stream=" +
      selectedStudent.stream;
    GetGenerateInsights(urls);
  };

  const { makeRequest: GetGenerateInsights } = useGetApi(
    (data: any) => {
      if (data["data"]) {
        const obj = {
          ...data["data"],
          persisted: false,
        };
        setStudentInsight(obj);
        setStudentInsightLoading(false);
        const insightObject = {
          ...data["data"],
          studentPSID: selectedStudent?.psid,
        };
        const insightObjectString = localStorage.getItem("insightObject");
        const storageInsightObject: any = insightObjectString
          ? JSON.parse(insightObjectString)
          : [];
        storageInsightObject.push(insightObject);
        localStorage.setItem(
          "insightObject",
          JSON.stringify(storageInsightObject)
        );
      } else {
        setStudentInsight(null);
        setStudentInsightError(data["message"]);
        setStudentInsightLoading(false);
      }
    },
    (error: any) => {
      setStudentInsight(null);
      setStudentInsightError(error["message"]);
      setStudentInsightLoading(false);
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error["message"] || "Failed to generate",
      });
    }
  );
  return (
    <>
      <StudentInsightListing
        viewAllComments={viewAllComments}
        setViewAllComments={setViewAllComments}
        studentpsid={selectedStudent?.psid}
        studentInsight={studentInsight}
        studentInsightLoading={studentInsightLoading}
        studentInsightError={studentInsightError}
        handleGenerateinsights={handleGenerateinsights}
      />
    </>
  );
}

export default StudentInsightHome;
